<template>
  <div class="sales_price_mg">
    <!--销售价管理头部搜索-->
    <div class="sales_price_mg_top clear">
      <div class="inb">
        <el-select v-model="selectStore" placeholder="店铺">
          <el-option v-for="item in storeList"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="inb">
        <input type="text" v-model="goodsId" placeholder="货号">
      </div>
      <div class="inb">
        <el-select v-model.trim="selectBrandType" placeholder="品牌">
          <el-option
            v-for="item in brandTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="inb">
        <el-select v-model="selectGoodsType" placeholder="分类">
          <el-option
            v-for="item in goodsTypeList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="inb">
        <el-select v-model="selectGender" placeholder="性别">
          <el-option
            v-for="item in genderList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="inb">
        <input type="text" v-model="marketSeason" placeholder="上市季节">
      </div>
      <button class="btn btn_normal" @click="queryData()">查询</button>
      <button class="btn btn_normal" @click="ctrlBtn('import', null)">批量导入</button>
      <button class="btn btn_normal" @click="exportShopGoodsPriceExcel()">导出</button>
      <button class="btn btn_normal" @click="ctrlBtn('batchDel', null)">批量删除</button>
      <button class="btn btn_normal" @click="getShopGoodsPriceImportExcelTemplet()">导入模板</button>
    </div>
    <!--销售价管理内容列表展示-->
    <div class="sales_price_mg_content">
      <table class="table tb_border">
        <thead>
        <tr>
          <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
          <th>店铺名称</th>
          <th>货号</th>
          <th>品牌</th>
          <th>分类</th>
          <th>性别</th>
          <th>上市季节</th>
          <th>零售价(元)</th>
          <th>日常价(元)</th>
          <th>活动价(元)</th>
          <th>编辑人</th>
          <th>编辑时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
          <td>{{item.ShopName}}</td>
          <td>{{item.GoodsId}}</td>
          <td>{{item.BrandName}}</td>
          <td>{{item.ClassName}}</td>
          <td>{{item.GenderName}}</td>
          <td>{{item.MarketSeason}}</td>
          <td>{{item.MarketPrice}}</td>
          <td>{{item.DailyPrice}}</td>
          <td>{{item.ActivityPrice}}</td>
          <td>{{item.CreaterName}}</td>
          <td>{{item.CreateTime | time}}</td>
          <td>
            <a href="#" @click="ctrlBtn('modify', item)">修改</a>
            <a href="#" @click="ctrlBtn('del', item)">删除</a>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="13">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <sales-price-mg-embed-msg v-if="isShow"
                              :title="dialogTitle"
                              :msg="msg"
                              :showType="showType"
                              @cancelbtn="getSelectDialogEmbed"></sales-price-mg-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import LoadingDialog from '../../public-component/loading-dialog';
  import MsgDialog from '../../public-component/msg-dialog';
  import SalesPriceMgEmbedMsg from './sales-price-mg-embed-msg'

  export default {
    name: 'sales-price-mg',
    components: {LoadingDialog, MsgDialog, SalesPriceMgEmbedMsg},
    watch: { // 深度watch
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    data() {
      return {
        list: [], // 列表信息
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        goodsId: null, // 货号
        storeList: [], // 店铺下拉
        selectStore: '', // 店铺选择
        brandTypeList: [], // 品牌下拉
        selectBrandType: '', // 品牌选择
        goodsTypeList: [], // 商品分类下拉
        selectGoodsType: '', // 商品分类选择
        genderList: [
          {id: 0, text: '性别'},
          {id: 1, text: '男'},
          {id: 2, text: '女'},
          {id: 3, text: '中性'},
          {id: 4, text: '童'}
        ], // 性别列表
        selectGender: 0, // 选择的性别
        marketSeason: null, // 上市季节
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isShow: false, // 提示框显示
        msg: null, // 弹出框传入内容
        dialogTitle: null, // 弹出框头部名
        showType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].id;
              this.getShopGoodsPricePageList();
            } else {
              this.storeList = res.data.resData;
              // this.selectStore = '';
            }
          } else {
            this.storeList = [];
            // this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 获取品牌下拉框信息
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
            this.selectBrandType = res.data.errorMsg;
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.goodsTypeList = res.data.resData;
            this.goodsTypeList.splice(0, 0, {id: '', text: '所有分类'});
            this.selectGoodsType = '';
          } else {
            this.goodsTypeList = [];
            this.selectGoodsType = res.data.errorMsg;
          }
        });
      },

      // 根据条件查询
      queryData() {
        this.currentPage = 1;
        this.isLoading = true;
        this.getShopGoodsPricePageList();
      },

      // 店铺售价分页数据
      getShopGoodsPricePageList() {
        this.loadingType = 'NOP';
        this.isLoading = true;
        const params = {
          ShopId: this.selectStore,
          GoodsId: this.goodsId,
          BrandId: this.selectBrandType,
          ClassId: this.selectGoodsType,
          Gender: this.selectGender,
          MarketSeason: this.marketSeason,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getShopGoodsPricePageList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < self.list.length; i++) {
                  self.checkboxModel.push(false);
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          })
        });
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 店铺货品售价导出
      exportShopGoodsPriceExcel() {
        this.loadingType = 'options';
        this.isLoading = true;
        const params = {
          ShopId: this.selectStore,
          GoodsId: this.goodsId,
          BrandId: this.selectBrandType,
          ClassId: this.selectGoodsType,
          Gender: this.selectGender,
          MarketSeason: this.marketSeason,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.exportShopGoodsPriceExcel, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 获取店铺货品售价导入模板
      getShopGoodsPriceImportExcelTemplet() {
        this.$axios.get(this.Global.getShopGoodsPriceImportExcelTemplet).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.showType = type;
        switch (type) {
          case 'import':
            this.msg = msg;
            this.dialogTitle = '导入';
            break;
          case 'modify':
            this.msg = msg;
            this.dialogTitle = '修改';
            break;
          case 'del':
            this.msg = [];
            this.msg.push(msg.Id);
            this.dialogTitle = '删除';
            break;
          case 'batchDel':
            this.msg = [];
            for (let i = 0; i < this.checkboxModel.length; i++) {
              if (this.checkboxModel[i]) {
                this.msg.push(this.list[i].Id);
              }
            }
            this.dialogTitle = '批量删除';
            break;
        }
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
      },

      // 订单导入
      importOrderExcel() {
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        // const formData = new window.FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importOrderExcel, formData).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (res.data.errorMsg.length && !res.data.resData) {
                self.uploadMsg = res.data.resData;
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
              if (res.data.resData) {
                self.isShow = true;
                self.errorTxt = res.data.errorMsg;
                self.msg = res.data.resData;
                self.dialogTitle = '错误提示';
              }
            }
          }, 500);
        });
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        if (val < this.checkboxModel.length) {
          this.checkboxModel = this.checkboxModel.splice(0, val);
        }
        this.getShopGoodsPricePageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.checkboxModel = [];
        this.getShopGoodsPricePageList();
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType === true) {
          this.getShopGoodsPricePageList();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getAllPXShopList();
      this.getAllBrandsList();
      this.getAllClassList();
      // this.getShopGoodsPricePageList();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";
  @import "../../../assets/css/style";

  .sales_price_mg {
    padding: 10px 5px;
    .sales_price_mg_top {
      & > div, & > button {
        margin-right: 15px;
        margin-bottom: 10px;
        float: left;
      }

      & > div {
        width: 140px;
      }

      input[type='text'] {
      }
    }
  }
</style>
<style>
  .el-menu{
    border-right-width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/sales-price-mg.vue